import { render, staticRenderFns } from "./HeaderNewsButton.vue?vue&type=template&id=1ee80b16&scoped=true"
import script from "./HeaderNewsButton.vue?vue&type=script&lang=js"
export * from "./HeaderNewsButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderNewsButton.vue?vue&type=style&index=0&id=1ee80b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee80b16",
  null
  
)

export default component.exports